import { render, staticRenderFns } from "./coffee-card-list.vue?vue&type=template&id=1602b4b9&"
import script from "./coffee-card-list.vue?vue&type=script&lang=js&"
export * from "./coffee-card-list.vue?vue&type=script&lang=js&"
import style0 from "./coffee-card-list.vue?vue&type=style&index=0&id=1602b4b9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports